import type { BaseProductData } from '../types';
import type { FilterSelection } from './getProductFilterValues';

const filterProducts = (
    products: BaseProductData[],
    filters: FilterSelection
): [boolean, BaseProductData[]] => {
    let filteredProducts = products;
    let areFiltersActive = false;

    for (const [name, { type, value }] of Array.from(Object.entries(filters))) {
        if (value.length > 0) {
            areFiltersActive = true;
            if (type === 'variant') {
                filteredProducts = filteredProducts
                    .map(item => ({
                        ...item,
                        variants: item.variants.filter(variant => {
                            const attributeValue =
                                variant.variationAttributes?.find(
                                    attribute => attribute.name === name
                                )?.value;

                            return (
                                attributeValue && value.includes(attributeValue)
                            );
                        }),
                    }))
                    .filter(product => product.variants.length > 0);
            }

            if (type === 'sibling') {
                filteredProducts = filteredProducts
                    .filter(item => !!item.siblingAttributes)
                    .filter(item => {
                        const attributeValue = item.siblingAttributes?.find(
                            attribute => attribute.name === name
                        )?.value;

                        return attributeValue && value.includes(attributeValue);
                    });
            }
        }
    }

    return [areFiltersActive, filteredProducts];
};

export default filterProducts;
